import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import '../../../Styles/Cart/AddressList.css';
import AddAddressModel from './AddAddressModel';
import { useTranslation } from 'react-i18next';
import axiosUserInstance from '../../../axiosUserInstance';
import CloseIcon from '../../../assets/svg/closeIcon';
import WhiteLocationIcon from '../../../assets/svg/WhiteLocationIcon';
import DownArrowIcon from '../../../assets/svg/DownArrowIcon';
import EditPencilIconSvg from '../../../assets/svg/editPencilIcon.jsx';
import DeleteIconSvg from '../../../assets/svg/deleteIcon.jsx';
import locationIcon from '../../../assets/svg/location-icon-address.svg';
import Loader from '../../../Components/Loader/Loader.jsx';

function AdressList({ handleClose, handleUpdateDeliveryAddress, selectedAddressIndex, setSelectedAddressIndex, }) {
    const { t } = useTranslation();
    const [addAddress, setAddAddress] = useState(false);
    const [editAddress, setEditAddress] = useState(null);
    const [addressList, setAddressList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenAddress = () => {
        setEditAddress(null);
        setAddAddress(true);
    };

    const handleCloseAddress = () => {
        setAddAddress(false);
        setEditAddress(null);
    };

    const handleDeleteAddress = async (id) => {
        try {
            await axiosUserInstance.delete(`/address/account/${id}`);
            getAddress();
        } catch (error) {
            console.error('Error deleting address:', error);
        }
    };
    
    const getAddress = async () => {
        setIsLoading(true);
        try {
            const response = await axiosUserInstance.get('/address/account/account_id');
            setIsLoading(false); 
            setAddressList(response?.data?.addresses);
        } catch (error) {
            console.error('Error fetching addresses:', error);
            setIsLoading(false); 
        }
    };

    useEffect(() => {
        getAddress();
    }, []);

    const handleCheckboxChange = (index) => {
        if (selectedAddressIndex === index) {
            setSelectedAddressIndex(null);
            localStorage.removeItem('selectedAddressIndex');
        } else {
            setSelectedAddressIndex(index);
            localStorage.setItem('selectedAddressIndex', index);
        }
    };

    useEffect(() => {
        const storedIndex = localStorage.getItem('selectedAddressIndex');
        if (storedIndex !== null) {
            setSelectedAddressIndex(parseInt(storedIndex, 10));
        } else if (addressList.length > 0) {
            setSelectedAddressIndex(0);
        }
    }, [addressList]);

    const getAddressType = () => {
        if (addressList.length === 0) return '';
        return addressList[selectedAddressIndex]?.Delivery_name || addressList[0]?.Delivery_name || '';
    };

    const handleAddAddress = (newAddress) => {
        setAddressList([...addressList, newAddress]);
    };

    const handleEditAddress = (address) => {
        setEditAddress(address);
        setAddAddress(true);
    };

    return (
        <div className="adress-list-main-container">
            <div className="hide-horizantal-line">
                <div className="horizantal-line-mobile"></div>
            </div>

            <div className="address-and-crossIcon-container">
                <Typography className='address-title' variant="h6">
                    {t('cart.address-title')}
                </Typography>
                <CloseIcon onClick={handleClose} className="cross-icon-location" />
            </div>
            <div className="cart-box-border"></div>
            <div className="address-container-in-model">
                <div className="delivery-location-home-desc-container">
                    <WhiteLocationIcon />
                    <div className="delivert-to-home-desc-container">
                        <h3 className="delivery-to-home-text">
                            {t('cart.delivery-to')} {getAddressType()}
                        </h3>
                        <p className="delivery-to-home-address">
                            {addressList[selectedAddressIndex]?.Address_line_1}, {addressList[selectedAddressIndex]?.City}, {addressList[selectedAddressIndex]?.State}-{addressList[selectedAddressIndex]?.ZIP}
                        </p>
                    </div>
                </div>
                <DownArrowIcon />
            </div>

            <div className="save-address-heading">
                <p className="saved-address">{t('cart.saved-address-title')}</p>
                <button className="add-new-address-btn" onClick={handleOpenAddress}>
                    {t('cart.add-new-address-title')}
                </button>
            </div>

            {addAddress && (
                <AddAddressModel
                    open={addAddress}
                    handleCloseAddress={handleCloseAddress}
                    handleAddAddress={handleAddAddress}
                    getAddress={getAddress}
                    editAddress={editAddress}
                    existingAddresses={addressList} 
                />
            )}

            {isLoading && (<Loader style={{borderRadius:'12px'}}/>) }
            <div className="address-list-scrollable">
                {addressList?.map((address, index) => (
                    <div 
                        key={index} 
                        className={`address-type-container ${selectedAddressIndex === index ? 'selected-address' : ''}`} 
                        onClick={() => handleCheckboxChange(index)}
                    >
                        <div className="address-details">
                            <img src={locationIcon} alt="location-icon" />
                            <div style={{width: '100%'}}>
                                <h4 className="address-type">{address?.Delivery_name}</h4>
                                <p className="address-type-address">
                                    {`${address?.Address_line_1}, ${address?.City}`}, {`${address?.State}-${address?.ZIP}`}
                                </p>
                            </div>
                        </div>
                        <div className="button-container">
                            <EditPencilIconSvg
                                onClick={() => handleEditAddress(address)}
                                color='#6D7383'
                                height={18}
                                width={18}
                            />
                            <DeleteIconSvg
                                onClick={() => handleDeleteAddress(address?.ID)}
                            />
                        </div>
                    </div>
                    
                ))}
            </div>


            <button
                className="update-delivery-address"
                onClick={() => {
                    handleUpdateDeliveryAddress(getAddressType());
                    handleClose();
                }}
                disabled={selectedAddressIndex === null || selectedAddressIndex === undefined} // Disable if no address selected
            >
                {t('cart.update-delivery-address')}
            </button>

        </div>
    );
}

export default AdressList;
